// Keep old shared #/ links working. Ignore Google's #google_vignette overlay hash.
const legacy=/^#\/(home|story|search|me|profile|login|signup|reset-password|admin|settings|support|privacy|terms|delete-account)(\/|$)/;
export function routePath(){
 if(legacy.test(location.hash))return location.hash.slice(1);
 const path=location.pathname==='/index.html'?'/':location.pathname.replace(/\/$/,'')||'/';
 return path.startsWith('/read/')?path.replace(/^\/read\//,'/story/'):path;
}
export function bridgeLegacyRoutes(){
 const normalize=()=>{if(!legacy.test(location.hash))return;const path=location.hash.slice(1).replace(/^\/story\//,'/read/');history.replaceState(history.state,'',path+location.search);};
 normalize();addEventListener('hashchange',normalize);
}
